import { ModelBase, Property } from '@skylab-shared/core';

export class VatTableItemModel extends ModelBase {
    @Property()
    public cost: number;

    @Property()
    public grossValue: number;

    @Property()
    public netValue: number;

    @Property()
    public vatRateId: number;

    @Property()
    public vatValue: number;

    @Property()
    public manual: boolean;
}
